import { compact } from 'lodash';
import { type LinkedService } from '../model/linkedservice/linkedservice';
import { ModelConstants } from '../model/model-constants';
import { GlobalVariables } from './globals';
import { type TridentArtifactTypeV2 } from '@trident/data-access-artifact';

export const azureCloudTypeConst = {
    AzurePublic: 'AzurePublic',
    AzureChina: 'AzureChina',
    AzureUSGovernment: 'AzureUSGovernment',
    AzureGermany: 'AzureGermany'
};

export enum ConnectionKind {
    AZURE_DATA_LAKE_STORAGE_GEN2 = 'AzureDataLakeStorage',
    AZURE_DATA_LAKE_STORAGE_GEN2_COSMOS_STRUCTURED_STREAM = 'AdlsGen2CosmosStructuredStream',
    AZURE_BLOBS = 'AzureBlobs',
    AZURE_BLOBS_COSMOS_STRUCTURED_STREAM = 'AzureDataLakeStoreCosmosStructuredStream',
    AZURE_DATA_EXPLORER = 'AzureDataExplorer',
    SQL = 'SQL',
    AZURE_DATA_PIPELINE_COSMOS_DB = 'DataPipelineCosmosDb',
    AZURE_COSMOS_DB_NOSQL_V2 = 'CosmosDB',
    AZURE_TABLE_STORAGE = 'AzureTables',
    AMAZON_S3 = 'AmazonS3',
    AMAZON_S3_COMPATIBLE = 'AmazonS3Compatible',
    AZURE_SQL_MI = 'AzureSqlMI',
    AZURE_POSTGRE_SQL = 'AzurePostgreSQL',
    AZURE_HORIZON_DB = 'AzureHorizonDB',
    AMAZON_RDS_FOR_SQL_SERVER = 'AmazonRdsForSqlServer',
    AMAZON_RDS_FOR_ORACLE = 'AmazonRdsForOracle',
    AMAZON_REDSHIFT = 'AmazonRedshift',
    ODATA = 'OData',
    GOOGLE_CLOUD_STORAGE = 'GoogleCloudStorage',
    IMPALA = 'Impala',
    SPARK = 'Spark',
    AZURE_DATABRICKS_WORKSPACE = 'AzureDatabricksWorkspace',
    HIVE = 'ApacheHive',
    POSTGRE_SQL = 'PostgreSQL',
    WEB = 'Web',
    SNOWFLAKE = 'Snowflake',
    DATABRICKS = 'Databricks',
    DATABRICKS_MULTI_CLOUD = 'DatabricksMultiCloud',
    DATAVERSE = 'CommonDataService',
    DYNAMICS_365 = 'Dynamics365',
    DYNAMICS_CRM = 'DynamicsCrm',
    DYNAMICS_AX = 'DynamicsAX',
    SHAREPOINT = 'SharePoint',
    MICROSOFT365 = 'Microsoft365',
    AZURE_DATA_LAKE_STORAGE_GEN1 = 'DataLake',
    GOOGLE_BIG_QUERY = 'GoogleBigQuery',
    AZURE_DATA_LAKE_ANALYTICS = 'DataLakeAnalytics',
    WEB_FOR_PIPELINE = 'WebForPipeline',
    HTTP_SERVER = 'HttpServer',
    REST_SERVICE = 'RestService',
    AZURE_FUNCTION = 'AzureFunction',
    AZURE_MACHINE_LEARNING = 'AzureMachineLearning',
    AZURE_BATCH = 'AzureBatch',
    MONGODB = 'MongoDBForPipeline',
    MONGODB_ATLAS = 'MongoDBAtlasForPipeline',
    HDFS='HdfsForPipeline',
    AZURE_COSMOSDB_FOR_MONGODB = 'AzureCosmosDBForMongoDB',
    SAP_HANA = 'SapHana',
    SAP_TABLE_MESSAGE_SERVER = 'SAPTableMessageServer',
    SAP_TABLE_APPLICATION_SERVER = 'SAPTableApplicationServer',
    SAP_BW_OPEN_HUB_MESSAGE_SERVER = 'SAPBWOpenHubMessageServer',
    SAP_BW_OPEN_HUB_APPLICATION_SERVER = 'SAPBWOpenHubApplicationServer',
    DB2 = 'DB2',
    FileSever = 'Folder',
    ODBC = 'Odbc',
    SFTP = 'SFTP',
    FTP = 'FTP',
    POWERBI_DATASETS = 'PowerBIDatasets',
    AZURE_KEY_VAULT = 'AzureKeyVault',
    AZURE_DATA_FACTORY = 'AzureDataFactory',
    AZURE_SYNAPSE_WORKSPACE = 'AzureSynapseWorkspace',
    MICROSOFT_TEAMS = 'MicrosoftTeams',
    MICROSOFT_OUTLOOK = 'MicrosoftOutlook',
    ORACLE = 'Oracle',
    ORACLE_CLOUD_STORAGE = 'OracleCloudStorage',
    FABRIC_DATA_PIPELINES = 'FabricDataPipelines',
    AZURE_AI_SEARCH = 'AzureAISearch',
    MYSQL = 'MySql',
    SAPCDC = 'SapApplication',
    MariaDB = 'MariaDBForPipeline',
    AZURE_FILE = 'AzureFiles',
    AZURE_HDINSIGHT_CLUSTER = 'AzureHDInsightCluster',
    AZURE_HDINSIGHT_ON_DEMAND = 'AzureHDInsightOnDemandCluster',
    SALESFORCE = 'Salesforce',
    SALESFORCE_SERVICE_CLOUD = 'SalesforceServiceCloud',
    AZURE_DATABASE_FOR_MYSQL = 'AzureDatabaseForMySQL',
    VERTICA = 'Vertica',
    GITHUB_SOURCE_CONTROL = 'GitHubSourceControl',
    SERVICE_NOW = 'ServiceNow',
    SPARK_JOB_DEFINITION = 'SparkJobDefinition',
    USER_DATA_FUNCTIONS = 'UserDataFunctions',
    NOTEBOOK = 'Notebook',
    FABRIC_AIRFLOW = 'FabricAirflow',
    COPY_JOB = 'CopyJob',
    FABRIC_SQL = 'FabricSql',
    WARHOUSE = 'Warehouse',
    LAKEHOUSE = 'Lakehouse',
    FABRIC_MATERIALIZED_LAKEHOUSE_VIEW = 'FabricMaterializedLakeView',
    SQL_ANALYTICS_ENDPOINT = 'SqlAnalyticsEndpoint',
    Teradata = 'Teradata',
    DATAFLOW = 'PowerPlatformDataflows',
    GREENPLUM = 'GreenplumForPipeline',
    INFORMIX = 'InformixForPipeline',
    PRESTO = 'Presto',
    CASSANDRA = 'Cassandra',
    JIRA = 'Jira',
    ATTIO = 'Attio',
    BITBUCKET = 'Bitbucket',
    ORACLE_FUSION = 'OracleFusion',
    MICROSOFT_ACCESS = 'MicrosoftAccess',
    QUICKBOOKS = 'QuickBooksForPipeline',
    SHOPIFY = 'Shopify',
    NETEZZA = 'Netezza',
    SAP_AZURE_DATA_LAKE_STORAGE_GEN2 = 'SAPAzureDataLakeStorageGen2',
    ONE_LAKE_FILE = 'OneLakeFile',
    SAP_DATASPHERE_GOOGLE_CLOUD_STORAGE = 'SAPDatasphereGoogleCloudStorage',
    SAP_DATASPHERE_AMAZON_S3 = 'SAPDatasphereAmazonS3',
    SAP_BUSINESS_DATA_CLOUD = 'SAPBusinessDataCloud',
    EVENT_STREAM = 'EventStream',
    FABRIC_SQL_ENDPOINT_METADATA = 'FabricSqlEndpointMetadata',
    DATA_BUILD_TOOL_JOB = 'DataBuildToolJob',
    VIVA_INSIGHTS = 'VivaInsights',
    DATA_QUALITY = 'DataQuality'
}

export type azureCloudTypeDef = 'AzurePublic' | 'AzureChina' | 'AzureGermany' | 'AzureUSGovernment';

export enum StorageAccountKind {
    BlockBlobStorage = 'BlockBlobStorage',
    BlobStorage = 'BlobStorage',
    FileStorage = 'FileStorage',
    GeneralPurposeV2 = 'StorageV2',
    GeneralPurposeV1 = 'Storage'
}

export const servicePrincipalCredentialTypes = {
    ServicePrincipalKey: 'ServicePrincipalKey',
    ServicePrincipalCert: 'ServicePrincipalCert'
};
export interface IArtifact {
    workspaceId: string;
    artifactId: string;
}

// TODO: Refactor this type
export type WorkspaceBuildInLinkedService = LinkedService & IArtifact;

export const artifactCredentialConnections: ConnectionKind[] = compact([
    ConnectionKind.FABRIC_SQL,
    ConnectionKind.WARHOUSE,
    ConnectionKind.LAKEHOUSE,
    ConnectionKind.SQL_ANALYTICS_ENDPOINT,
    ConnectionKind.EVENT_STREAM
]);

export const artifactCredentialTypes: string[] = compact([
    ModelConstants.fabricSqlCredentialLinkedService,
    ModelConstants.warehouseCredentialLinkedService,
    ModelConstants.lakehouseCredentialLinkedService,
    ModelConstants.sqlAnalyticsEndpointCredentialLinkedService,
    ModelConstants.eventStreamCredentialLinkedService
]);

export type artifactCredentialType = ConnectionKind.FABRIC_SQL | ConnectionKind.WARHOUSE | ConnectionKind.LAKEHOUSE | ConnectionKind.SQL_ANALYTICS_ENDPOINT | ConnectionKind.EVENT_STREAM;
export const artifactCredentialToArtifactMap: {[key in artifactCredentialType]: string} = {
    'FabricSql': ModelConstants.fabricSqlLinkedService,
    'Warehouse': ModelConstants.dataWarehouseLinkedService,
    'Lakehouse': ModelConstants.lakehouseLinkedService,
    'SqlAnalyticsEndpoint': ModelConstants.sqlAnalyticsEndpointLinkedService,
    'EventStream': ModelConstants.eventStreamLinkedService
};

//artifact to its linkedService type in fabric
export type artifactLinkedSerivceType =
    | 'FabricSqlDatabase'
    | 'DataWarehouse'
    | 'Lakehouse'
    | 'KustoDatabase'
    | 'SqlAnalyticsEndpoint'
    | 'EventStream';
export const artifactLinkedSerivceToKindMap = {
    'FabricSqlDatabase': ModelConstants.fabricSqlArtifactType,
    'DataWarehouse': ModelConstants.dataWarehouseArtifactType,
    'Lakehouse': ModelConstants.lakehouseArtifactType,
    'KustoDatabase': ModelConstants.kustoDatabaseArtifactType,
    'SqlAnalyticsEndpoint': ModelConstants.sqlAnalyticsEndpointArtifactType,
    'EventStream': ModelConstants.eventStreamArtifactType
};

export const artifactRequriedAttributes = [
    'artifactId',
    'endpoint',
    'workspaceId'
];

export const artifactsSupportDMTSCredential: TridentArtifactTypeV2[] = compact([
    ModelConstants.fabricSqlArtifactType,
    ModelConstants.dataWarehouseArtifactType,
    ModelConstants.lakehouseArtifactType,
    GlobalVariables.enableKQLDMTSCredential
        ? ModelConstants.kustoDatabaseArtifactType
        : undefined,
    GlobalVariables.enableSQLAnalyticsEndpoint ? ModelConstants.sqlAnalyticsEndpointArtifactType : undefined,
    ModelConstants.eventStreamArtifactType
]);

export const artifactSupportNoneDMTS: TridentArtifactTypeV2[] = [
    ModelConstants.dataWarehouseArtifactType,
    ModelConstants.lakehouseArtifactType
];
